export default {
	root: {
		fontFamily: 'FustatMedium',
		letterSpacing: '-0.02em',
		color: '#302E2A',
	},
	headingLarge: {
		m: 0,
		fontFamily: 'IvyPrestoHeadlineRegular',
		fontSize: '35px',
		letterSpacing: '0.03em',
	},
	headingSmall: {
		m: 0,
		mb: { xs: 2, md: 3 },
		fontSize: { xs: '15px', md: '17px' },
		fontFamily: 'FustatBold',
	},
	definitionList: {
		m: 0,
	},
	definitionTitle: {
		fontSize: '16px',
		fontFamily: 'FustatBold',
		fontWeight: 500,
		':not(:first-of-type)': {
			mt: 2,
		}
	},
	definitionText: {
		fontSize: '16px',
		fontFamily: 'FustatMedium',
	},
	textLink: {
		color: '#125e82',
		':hover': {
			color: '#1c465e',
			backgroundColor: 'unset'
		},
	}
}